// src/components/analytics/CustomerTierDistributionChart.js
import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const CustomerTierDistributionChart = ({ dateRange, selectedProgram }) => {
    // Mock data for customer distribution by tier/points
    const generateData = () => {
        let labels, dataPoints, backgroundColors;

        if (selectedProgram === 'VIP Tier Rewards') {
            labels = ['Bronze Tier', 'Silver Tier', 'Gold Tier', 'Platinum Tier'];
            dataPoints = [400, 250, 100, 30];
            backgroundColors = [
                'rgba(156, 163, 175, 0.8)', // Gray-500
                'rgba(107, 114, 128, 0.8)', // Gray-600
                'rgba(251, 191, 36, 0.8)',  // Amber-400
                'rgba(59, 130, 246, 0.8)',  // Blue-500
            ];
        } else { // Defaulting to point ranges for other programs or "All Programs"
            labels = ['0-500 pts', '501-1000 pts', '1001-2500 pts', '2501-5000 pts', '5000+ pts'];
            dataPoints = [300, 250, 400, 200, 100];
            backgroundColors = [
                'rgba(239, 68, 68, 0.8)',    // Red
                'rgba(251, 191, 36, 0.8)',   // Amber
                'rgba(59, 130, 246, 0.8)',   // Blue
                'rgba(168, 85, 247, 0.8)',   // Purple
                'rgba(16, 185, 129, 0.8)',   // Emerald
            ];
        }

        return {
            labels: labels,
            datasets: [
                {
                    data: dataPoints,
                    backgroundColor: backgroundColors,
                    borderColor: '#ffffff',
                    borderWidth: 2,
                },
            ],
        };
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    font: { family: 'Inter, sans-serif' },
                    color: '#374151',
                },
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                bodyFont: { family: 'Inter, sans-serif' },
                titleFont: { family: 'Inter, sans-serif', weight: 'bold' },
                callbacks: {
                    label: function(context) {
                        let label = context.label || '';
                        if (label) {
                            label += ': ';
                        }
                        const value = context.raw;
                        const total = context.dataset.data.reduce((acc, current) => acc + current, 0);
                        const percentage = ((value / total) * 100).toFixed(1) + '%';
                        return `${label} ${value} (${percentage})`;
                    }
                }
            }
        },
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6 h-96 flex flex-col">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Customer Distribution</h3>
            <p className="text-sm text-gray-500 mb-4">Breakdown of customers by loyalty tier or points range.</p>
            <div className="flex-1 relative flex items-center justify-center"> {/* Centering for pie chart */}
                <Pie data={generateData()} options={options} />
            </div>
        </div>
    );
};

export default CustomerTierDistributionChart;